import { TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles({
  rootInput: {
    "& label": {
      color: "#8D8D8D",
      fontSize: "1.5rem",
      letterSpacing: "0.09938em",
    },
    "& div": {
      "&.MuiFilledInput-root": {
        fontSize: "2rem",
        fontWeight: "500",
        color: "#FFFFFF",
      },
    },
    "& p": {
      "&.MuiFormHelperText-root": {
        fontSize: "1.5rem",
        marginLeft: "0px",
      },
    },
  },
});

function Input(props) {
  const classes = useStyles();
  const {
    id,
    variant,
    label,
    color,
    name,
    type,
    value,
    onChange,
    error = null,
    ...others
  } = props;
  return (
    <TextField
      className={classes.rootInput}
      id={id || "outlined-basic"}
      variant={variant || "outlined"}
      color={color || "secondary"}
      label={label}
      name={name}
      type={type || "text"}
      value={value}
      onChange={onChange}
      autoComplete="off"
      {...others}
      {...(error && { error: true, helperText: error })}
    />
  );
}

export default Input;
